import h337 from "heatmap.js";
import { useEffect, useRef, useState } from "react";
// import AFLBall from "../assets/AFLBall.png";
import RedSherrin from "../assets/RedSherrin.png";
import { addAlPhatoRGBColour, calculateDistanceToBall, writeText } from "../utils/Utils";

function Ground({
  panelSize,
  groundSize,
  match,
  teamA,
  teamB,
  teamU,
  selectedPeriod,
  videoProgress,
  catapultOffset,
  showNames,
  selectedPlayers,
  currentChain,
  activePlayer,
  distancePlayers,
  heatMapPlayer,
  showActivityWithHeatmap,
  heatmapOpacity,
  dynamicHeatmap,
  umpireTracking,
  simulationSpeed,
  onSensorData,
}) {
  const canvasRef = useRef();
  const ref = useRef(null);
  const heatmapRef = useRef(null);
  const [xmargin, setXmargin] = useState(20);
  const [ymargin, setYmargin] = useState(40);
  const [groundWidth, setGroundWidth] = useState(groundSize.width);
  const [groundHeight, setGroundHeight] = useState(groundSize.height);
  const [goalSquareTop, setGoalSquareTop] = useState(0);
  const [goalSquareBottom, setGoalSquareBottom] = useState(0);
  const [scale, setScale] = useState(1);
  const [teamAplayers, setTeamAPlayers] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [lastTime, setLastTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [basecoord, setBaseCoord] = useState(null);
  const [ballImage, setBallImage] = useState(null);
  const intervalRef = useRef(null);

  const doDrawPlayerPath = (ctx, pl, startevent, endevent) => {
    const starttime =
      match.home_catapult_session?.periods[selectedPeriod - 1].start_time +
      catapultOffset;
    const stime =
      parseFloat(startevent["PERIOD_SECS"]) +
      match.periods[selectedPeriod - 1].firstBounceVideoTime +
      starttime;
    const etime =
      parseFloat(endevent["PERIOD_SECS"]) +
      match.periods[selectedPeriod - 1].firstBounceVideoTime +
      starttime;

    let alpha = 1;
    if (currentTime > etime) {
      alpha = 1 - (currentTime - etime) / 10;
    }
    let col = addAlPhatoRGBColour("rgb(0, 0, 0)", alpha);
    if (pl.fill_colour) {
      col = addAlPhatoRGBColour(pl.fill_colour, alpha);
    }
    ctx.strokeStyle = col;
    ctx.lineWidth = 2;
    // if (currentTime > etime) {
    //   // set line dash
    //   ctx.setLineDash([2, 2]);
    // } else {
    //   ctx.setLineDash([]);
    // }
    ctx.beginPath();
    let c = 0;

    for (
      var n = 0;
      n < pl?.playerSensorData[selectedPeriod - 1].data?.length;
      n++
    ) {
      const sd = pl.playerSensorData[selectedPeriod - 1].data[n];
      const sdtime = sd.ts + sd.cs / 100;
      if (sdtime >= stime) {
        if (sd.x === 0 && sd.y === 0) {
          continue;
        }
        const xx = -sd.y * scale;
        const yy = -sd.x * scale;
        let x = panelSize.width / 2 + xx;
        let y = panelSize.height / 2 + yy;

        if (c === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
        c++;

        if (sdtime >= etime) {
          break;
        }
      }
    }
    ctx.stroke();
    ctx.setLineDash([]);
  };

  const getXYOfPlayerByTime = (pl, time) => {
    for (var n = 0; n < pl?.data?.length; n++) {
      const sd = pl.data[n];
      const sdtime = sd.ts + sd.cs / 100;
      if (sdtime >= time) {
        if (sd.x === 0 && sd.y === 0) {
          continue;
        }
        return { x: sd.x, y: sd.y };
      }
    }
    return null;
  };

  const getXYOfPlayerByOdometer = (pl, odometer) => {
    for (var n = 0; n < pl?.data?.length; n++) {
      const sd = pl.data[n];
      if (sd.o >= odometer) {
        if (sd.x === 0 && sd.y === 0) {
          continue;
        }
        return { x: sd.x, y: sd.y };
      }
    }
    return null;
  };

  const doDrawPlayer = (ctx, pl, colour, textcolour, endevent) => {
    let activePlayerCoords = null;
    for (var n = 0; n < pl?.data?.length; n++) {
      const sd = pl.data[n];
      const sdtime = sd.ts + sd.cs / 100;
      if (sdtime >= currentTime) {
        if (sd.x === 0 && sd.y === 0) {
          continue;
        }
        if (colour === "" && textcolour === "") {
          activePlayerCoords = { x: sd.x, y: sd.y };
          return activePlayerCoords;
        }
        onSensorData({ athleteId: pl.athlete_id, sd: sd });
        const xx = -sd.y * scale;
        const yy = -sd.x * scale;
        let x = panelSize.width / 2 + xx;
        let y = panelSize.height / 2 + yy;

        for (var nn = n; nn < n + 20; nn++) {
          const sdd = pl.data[nn];
          if (!sdd || (sdd.x === 0 && sdd.y === 0)) {
            continue;
          }
          const xx = -sdd.y * scale;
          const yy = -sdd.x * scale;
          let x1 = panelSize.width / 2 + xx;
          let y1 = panelSize.height / 2 + yy;
          ctx.beginPath();
          ctx.moveTo(x, y);
          ctx.lineTo(x1, y1);
        }
        ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.closePath();

        if (
          selectedPlayers.filter((plx) => plx.id === pl.athlete_id).length > 0
        ) {
        }

        ctx.fillStyle = colour;
        ctx.beginPath();
        ctx.arc(x, y, 10, 0, Math.PI * 2);
        ctx.fill();

        const uts = umpireTracking.filter((u) => u.umpire.id === pl.athlete_id);
        if (uts.length > 0) {
          const ut = uts[0];
          if (!ut.varOdometer || ut.varOdometer === 0) {
            ut.varOdometer = sd.o;
            ut.lastOdometer = 0;
            // console.log(
            //   "***",
            //   ut.umpire.last_name,
            //   " varOdometer set to ",
            //   ut.varOdometer
            // );
          } else {
            // console.log(
            //   "***",
            //   ut.umpire.last_name,
            //   " varOdometer current ",
            //   ut.varOdometer
            // );
            const varspeedpc = simulationSpeed / 100;
            const vardist =
              ut.varOdometer + (sd.o - ut.lastOdometer) * (1 + varspeedpc);
            ut.varOdometer = vardist;
            const varxy = getXYOfPlayerByOdometer(pl, vardist);
            if (varxy) {
              const xx = -varxy.y * scale;
              const yy = -varxy.x * scale;
              let x = panelSize.width / 2 + xx;
              let y = panelSize.height / 2 + yy;

              const starttime =
                match.home_catapult_session?.periods[selectedPeriod - 1]
                  .start_time + catapultOffset;
              const etime =
                parseFloat(endevent["PERIOD_SECS"]) +
                match.periods[selectedPeriod - 1].firstBounceVideoTime +
                starttime;

              let alpha = 1;
              if (currentTime > etime) {
                alpha = 1 - (currentTime - etime) / 10;
              }
              ctx.strokeStyle = addAlPhatoRGBColour("rgb(0,0,0)", alpha);
              ctx.lineWidth = 2;
              let col = addAlPhatoRGBColour(colour, alpha);
              ctx.fillStyle = col;
              ctx.beginPath();
              ctx.arc(x, y, 6, 0, Math.PI * 2);
              ctx.fill();
              ctx.stroke();
            }
          }
          setLastTime(currentTime);
          ut.lastOdometer = sd.o;
        }

        // activePlayerCoords = { x: sd.x, y: sd.y };
        // if (activePlayer && activePlayer.id === pl.athlete_id) {
        //   ctx.strokeStyle = "magenta"; //"#CCFF02";
        //   ctx.lineWidth = 4;
        //   ctx.stroke();
        //   // ctx.fillStyle = "yellow";
        //   // ctx.beginPath();
        //   // ctx.arc(x, y, 10, 0, Math.PI * 2);
        //   // ctx.fill();
        // }
        writeText(
          {
            ctx: ctx,
            text: pl.jersey,
            x: x,
            y: y - 4,
          },
          {
            textAlign: "center",
            font: "Arial",
            fontSize: 12,
            color: textcolour,
          }
        );
        if (showNames) {
          ctx.beginPath();
          var width = ctx.measureText(pl.athlete_last_name).width;
          ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
          ctx.fillRect(x - width / 2, y + 8, width, 10);
          writeText(
            {
              ctx: ctx,
              text: pl.athlete_last_name.toUpperCase(),
              x: x,
              y: y + 10,
            },
            {
              textAlign: "center",
              font: "Arial",
              fontSize: 8,
              color: "white",
            }
          );
        }
        break;
      }
    }
    return activePlayerCoords;
  };

  const draw = () => {
    const ctx = canvasRef.current.getContext("2d");
    drawGround(ctx);
    const endevent = umpireTracking.length > 0 ? umpireTracking[umpireTracking.length - 1].events[umpireTracking[umpireTracking.length - 1].events.length - 1] : null;
    for (var umpire of umpireTracking) {
      doDrawPlayerPath(
        ctx,
        umpire.umpire,
        umpire.events[0],
        umpire.events[umpire.events.length - 1]
      );
    }
    if (!heatMapPlayer || showActivityWithHeatmap) {
      // Remove all elements with the class 'heatmap-canvas'
      [...document.getElementsByClassName("heatmap-canvas")].forEach((e) =>
        e.remove()
      );
      if (!teamA || !teamB || !teamU) {
        return;
      }

      for (var pl of teamA?.catapultPlayers) {
        if (
          teamA.show === true ||
          distancePlayers.find((p) => p.id === pl.id)
        ) {
          doDrawPlayer(
            ctx,
            pl.playerSensorData[selectedPeriod - 1],
            "blue",
            "white",
            endevent
          );
        }
      }
      for (var pl of teamB?.catapultPlayers) {
        if (
          teamB.show === true ||
          distancePlayers.find((p) => p.id === pl.id)
        ) {
          doDrawPlayer(
            ctx,
            pl.playerSensorData[selectedPeriod - 1],
            "cyan",
            "black",
            endevent
          );
        }
      }
      for (var pl of teamU?.catapultPlayers) {
        if (
          teamU.show === true ||
          distancePlayers.find((p) => p.id === pl.id)
        ) {
          doDrawPlayer(
            ctx,
            pl.playerSensorData[selectedPeriod - 1],
            pl.fill_colour,
            pl.text_colour,
            endevent
          );
        }
      }
      let xact = -10000;
      let yact = -10000;
      // console.log(activePlayer ? activePlayer.statscode : "no active player");
      if (activePlayer) {
        if (activePlayer.statscode === "GOAL") {
          // goal is at the middle of the ground
          xact = panelSize.width / 2;
          yact = panelSize.height / 2;
        } else if (activePlayer.statscode === "OOBO") {
        } else if (
          activePlayer.statscode === "BEHI" ||
          activePlayer.statscode.substring(0, 4) === "RUSH"
        ) {
          if (activePlayer.sensorData.y < 0) {
            xact = goalSquareTop.x + goalSquareTop.width / 2;
            yact = goalSquareTop.y + goalSquareTop.height / 2;
          } else {
            xact = goalSquareBottom.x + goalSquareBottom.width / 2;
            yact = goalSquareBottom.y + goalSquareBottom.height / 2;
          }
        } else {
          const actloc = doDrawPlayer(
            ctx,
            activePlayer.playerSensorData[selectedPeriod - 1],
            "",
            ""
          );
          if (actloc) {
            const xx = -actloc.y * scale;
            const yy = -actloc.x * scale;
            xact = panelSize.width / 2 + xx;
            yact = panelSize.height / 2 + yy;
            if (distancePlayers && distancePlayers.length > 0) {
              for (var pl of distancePlayers) {
                const distance = calculateDistanceToBall(pl, activePlayer, selectedPeriod, currentTime);
                if (distance) {
                  const xx = -pl.sensorData.y * scale;
                  const yy = -pl.sensorData.x * scale;
                  let x = panelSize.width / 2 + xx;
                  let y = panelSize.height / 2 + yy;

                  //draw line from active player to distance player
                  ctx.beginPath();
                  ctx.moveTo(xact, yact);
                  ctx.lineTo(x, y);
                  ctx.strokeStyle = "rgba(255, 255, 255, 0.4)";
                  ctx.lineWidth = 1;
                  ctx.stroke();
                  ctx.closePath();

                  ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
                  ctx.fillRect(x - 20, y + 8, 40, 12);
                  writeText(
                    {
                      ctx: ctx,
                      text: `${distance}m`,
                      x: x,
                      y: y + 10,
                    },
                    {
                      textAlign: "center",
                      font: "Arial",
                      fontSize: 10,
                      color: "white",
                    }
                  );
                }
              }
            }
          }
        }
        // draw ball (active player) if exists
        if (xact !== 0 && yact !== 0) {
          if (ballImage) {
            ctx.drawImage(ballImage, xact - 16, yact - 10, 30, 20);
          }
          ctx.strokeStyle = "black";
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.ellipse(xact, yact, 10, 7, 0, 0, Math.PI * 2);
          ctx.stroke();
        }
      }
    }
    if (heatMapPlayer) {
      // Remove all elements with the class 'heatmap-canvas'
      [...document.getElementsByClassName("heatmap-canvas")].forEach((e) =>
        e.remove()
      );

      var heatmapInstance = h337.create({
        container: heatmapRef.current,
        radius: 15,
        opacity: heatmapOpacity,
        visible: true,
      });
      let points = [];
      let max = 10;
      for (var dt of heatMapPlayer.playerSensorData[selectedPeriod - 1].data) {
        if (dynamicHeatmap) {
          const sdtime = dt.ts + dt.cs / 100;
          if (sdtime >= currentTime) {
            break;
          }
        }
        const xx = -dt.y * scale;
        const yy = -dt.x * scale;
        let x = panelSize.width / 2 + xx;
        let y = panelSize.height / 2 + yy;
        points.push({
          x: x,
          y: y,
          value: 1,
        });
      }
      var data = {
        max: max,
        data: points,
      };
      heatmapInstance.setData(data);
    }
  };

  const drawGround = (ctx) => {
    const { width, height } = panelSize;

    // Set the canvas size
    canvasRef.current.width = width;
    canvasRef.current.height = height;

    const ww = width - 2 * xmargin;
    const sc = ww / groundSize.width;
    setScale(sc);
    const hh = groundSize.height * sc;
    setGroundWidth(ww);
    setGroundHeight(hh);
    const topy = (height - hh) / 2;
    setYmargin(topy);
    const bottomy = hh + topy;
    const m50 = 50 * sc;
    const m25 = 25 * sc;
    const m10 = 10 * sc;
    const m9 = 9 * sc;
    const m3 = 3 * sc;
    // Draw the ground
    ctx.fillStyle = "darkgreen";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "green";
    ctx.beginPath();
    ctx.ellipse(width / 2, height / 2, ww / 2, hh / 2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = "white";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.save();
    ctx.clip();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, topy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, bottomy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    setGoalSquareTop({ x: width / 2 - m9 / 2, y: topy, width: m9, height: m9 });
    setGoalSquareBottom({
      x: width / 2 - m9 / 2,
      y: bottomy - m9,
      width: m9,
      height: m9,
    });
    ctx.strokeRect(width / 2 - m25, height / 2 - m25, m50, m50);
    ctx.strokeRect(width / 2 - m9 / 2, topy, m9, m9);
    ctx.strokeRect(width / 2 - m9 / 2, bottomy - m9, m9, m9);
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m3 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m10 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(width / 2 - m10 / 2, height / 2);
    ctx.lineTo(width / 2 + m10 / 2, height / 2);
    ctx.stroke();
    ctx.restore();
  };

  const startTimer = () => {
    setIsActive(true);
    intervalRef.current = setInterval(() => {
      setCurrentTime((prev) => prev + 0.1);
    }, 100);
    // console.log(currentTime);
  };

  const pauseTimer = () => {
    setIsActive(false);
    clearInterval(intervalRef.current);
  };

  const resetTimer = () => {
    setIsActive(false);
    setCurrentTime(
      match.home_catapult_session.periods[selectedPeriod - 1].start_time
    );
    clearInterval(intervalRef.current);
  };

  const doInit = async () => {
    // setCurrentTime(
    //   match.home_catapult_session.periods[selectedPeriod - 1].start_time + 10
    // );
    // startTimer();
    if (!ballImage) {
      const img = new Image();
      img.src = RedSherrin;
      img.onload = () => {
        setBallImage(img);
      };
      img.onerror = () => {
        console.error("Image failed to load.");
      };
    }
  };

  useEffect(() => {
    doInit();
    draw();
  }, [panelSize, groundSize]);

  useEffect(() => {
    // console.log(currentTime);
    draw();
  }, [currentTime]);

  useEffect(() => {
    // console.log(videoProgress);
    const starttime =
      match.home_catapult_session?.periods[selectedPeriod - 1].start_time +
      catapultOffset;
    setCurrentTime(starttime + videoProgress);
    //   startTimer();
  }, [videoProgress]);

  useEffect(() => {
    for (var ut of umpireTracking) {
      ut.varOdometer = 0;
      ut.lastOdometer = 0;
    }
  }, [umpireTracking[0]?.update]);

  return (
    <div
      className="Ground"
      ref={ref}
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      <canvas
        id="canvas"
        ref={canvasRef}
        width={panelSize?.width}
        height={panelSize?.height}
        style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
      ></canvas>
      <div
        id="heatmapArea"
        ref={heatmapRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: `${panelSize?.width}px}`,
          height: `${panelSize?.height}px`,
          zIndex: 2,
        }}
      ></div>
    </div>
  );
}

export default Ground;
